import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Avatar from "react-avatar";
const Sidebar = (props) => {
  const [name, setName] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [production, setProduction] = useState(null);
  useEffect(() => {
    setName(props.data);
    setProduction(props.appname);
  }, [props.data, props.appname]);
  document.body.className =
    "sidebar-mini layout-fixed layout-navbar-fixed layout-footer-fixed";
  const changeDisplay = (_id) => {
    const li = document.getElementById(_id);
    const ul = li.getElementsByTagName("ul")[0];
    if (li.classList.contains("menu-open")) {
      li.classList.remove("menu-is-opening", "menu-open", "animate-scroll");
      ul.classList.add("no_display");
      ul.classList.remove("display_block");
    } else {
      li.classList.add("menu-is-opening", "menu-open", "animate-scroll");
      ul.classList.remove("no_display");
      ul.classList.add("display_block");
    }
  };
  const toggleSubMenu = () => {
    setIsOpen(!isOpen);
  };
  if (name && production) {
    return (
      <aside className="main-sidebar sidebar-dark-primary elevation-4 background-2">
        <a href="/" className="brand-link">
          <img
            src={window.location.origin + "/dist/img/primlogo.png"}
            alt="primary Logo"
            className="brand-image"
            style={{ opacity: 1, maxHeight: "45px" }}
          />
        </a>

        <div className="sidebar">
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              <Avatar
                name={props.name}
                size="40"
                round={true}
                maxInitials={2}
                color="grey"
              />
            </div>
            <div className="info">
              <Link to="/profile" className="d-block">
                {name.name}
              </Link>
            </div>
          </div>

          <div className="user-panel mt-3  pb-3 mb-3">
            <div className="info">
              <label
                className={
                  production.production
                    ? "badge badge-success d-block"
                    : "badge badge-danger d-block"
                }
              >
                {production.production
                  ? "Production Environment"
                  : "Preview Environment"}
              </label>
            </div>
          </div>

          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              id="navColumn"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item menu-open animate-scroll">
                <a
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSubMenu();
                  }}
                  className={isOpen ? "nav-link active" : "nav-link"}
                >
                  <i className="nav-icon fas fa-tachometer-alt"></i>
                  <p>
                    Home
                    <i
                      className={`right fas fa-angle-${isOpen ? "right" : "left"}`}
                    ></i>
                  </p>
                </a>
                <ul
                  className={`nav nav-treeview ${isOpen ? "menu-open" : "d-none"}`}
                >
                  <li className="nav-item">
                    <Link
                      to="/"
                      className={
                        props.match.url === "/" ||
                        props.match.url === "/dashboard"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="far fa-circle nav-icon"></i>
                      <p>Dashboard</p>
                    </Link>
                  </li>

                  {/* </li> */}
                  <li className="nav-item" id="layoutCenter">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("layoutCenter");
                      }}
                      style={
                        name.superAdmin === true || name.admin === true
                          ? null
                          : { opacity: 0.4 }
                      }
                      className={
                        props.match.url === "/colors" ||
                        props.match.url === "/fonts" ||
                        props.match.url === "/branding"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-copy"></i>
                      <p>
                        Layout Center
                        <i className="fas fa-angle-left right"></i>
                      </p>
                    </a>
                    <ul
                      className={
                        name.superAdmin === true || name.admin === true
                          ? "nav nav-treeview no_display"
                          : "nav nav-treeview no_display"
                      }
                    >
                      <li className="nav-item">
                        <Link
                          to="/colors"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/colors"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Colors</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/fonts"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/fonts"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Fonts</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/branding"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/branding"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Branding</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item" id="contentCenter">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("contentCenter");
                      }}
                      style={
                        name.superAdmin === true || name.admin === true
                          ? null
                          : { opacity: 0.4 }
                      }
                      className={
                        props.match.url === "/vcms" ||
                        props.match.url === "/live"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-video"></i>
                      <p>
                        Content Center
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </a>
                    <ul
                      className={
                        name.superAdmin === true || name.admin === true
                          ? "nav nav-treeview no_display"
                          : "nav nav-treeview no_display"
                      }
                    >
                      <li className="nav-item">
                        <Link
                          to="/vcms"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/vcms"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Connect to VCMS</p>
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="/live"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/live"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Live Stream</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item" id="controlCenter">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("controlCenter");
                      }}
                      style={
                        name.editor === true ||
                        name.superAdmin === true ||
                        name.admin === true
                          ? null
                          : { opacity: 0.4 }
                      }
                      className={
                        props.match.url === "/pages" ||
                        props.match.url.indexOf("page") > -1 ||
                        props.match.url === "/menu" ||
                        props.match.url === "/elements" ||
                        props.match.url.indexOf("item") > -1 ||
                        props.match.url.indexOf("tab") > -1 ||
                        props.match.url === "/tickers" ||
                        props.match.url.indexOf("ticker") > -1 ||
                        props.match.url === "/setting" ||
                        props.match.url === "/websetting" ||
                        props.match.url === "/appsetting" ||
                        props.match.url === "/files" ||
                        props.match.url === "/footer" ||
                        props.match.url === "/images"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-book"></i>
                      <p>
                        Control Center
                        <i className="fas fa-angle-left right"></i>
                      </p>
                    </a>
                    <ul
                      className={
                        name.editor === true ||
                        name.superAdmin === true ||
                        name.admin === true
                          ? "nav nav-treeview no_display"
                          : "nav nav-treeview no_display"
                      }
                    >
                      <li className="nav-item">
                        <Link
                          to="/pages"
                          style={
                            name.editor === true ||
                            name.superAdmin === true ||
                            name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/pages" ||
                            props.match.url.indexOf("page") > -1
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Pages</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/menu"
                          style={
                            name.editor === true ||
                            name.superAdmin === true ||
                            name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/menu"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Menu</p>
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="/elements"
                          style={
                            name.editor === true ||
                            name.superAdmin === true ||
                            name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/elements" ||
                            props.match.url.indexOf("item") > -1 ||
                            props.match.url.indexOf("tab") > -1
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Elements</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/tickers"
                          style={
                            name.editor === true ||
                            name.superAdmin === true ||
                            name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/tickers" ||
                            props.match.url.indexOf("ticker") > -1
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Ticker</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/setting"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/setting"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>General Settings</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/websetting"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/websetting"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Web Settings</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/appsetting"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/appsetting"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>App Settings</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/footer"
                          style={
                            name.editor === true ||
                            name.superAdmin === true ||
                            name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/footer"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Footer</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/images"
                          style={
                            name.superAdmin === true ||
                            name.admin === true ||
                            name.editor === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/images"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Images</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/files"
                          style={
                            name.superAdmin === true ||
                            name.admin === true ||
                            name.editor === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/files"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Files</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/language"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className="nav-link"
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Languages</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item" id="monetize">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("monetize");
                      }}
                      style={
                        name.superAdmin === true || name.admin === true
                          ? null
                          : { opacity: 0.4 }
                      }
                      className={
                        props.match.url === "/adTag"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-play"></i>
                      <p>
                        Monetize
                        <i className="fas fa-angle-left right"></i>
                      </p>
                    </a>
                    <ul
                      className={
                        name.superAdmin === true || name.admin === true
                          ? "nav nav-treeview no_display"
                          : "nav nav-treeview no_display"
                      }
                    >
                      <li className="nav-item">
                        <Link
                          to="/adTag"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/adTag"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>AdTag</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item" id="analytics">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("analytics");
                      }}
                      className={
                        props.match.url === "/analytics"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-table"></i>
                      <p>
                        Analytics & SEO
                        <i className="fas fa-angle-left right"></i>
                      </p>
                    </a>
                    <ul className="nav nav-treeview no_display">
                      <li className="nav-item">
                        <Link
                          to="/analytics"
                          className={
                            props.match.url === "/analytics"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Connect to a Analytics</p>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item" id="subscriptionCenter">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("subscriptionCenter");
                      }}
                      style={
                        name.superAdmin === true || name.admin === true
                          ? null
                          : { opacity: 0.4 }
                      }
                      className={
                        props.match.url === "/subscription"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-dollar-sign"></i>
                      <p>
                        Subscription Center
                        <i className="fas fa-angle-left right"></i>
                      </p>
                    </a>
                    <ul
                      className={
                        name.superAdmin === true || name.admin === true
                          ? "nav nav-treeview no_display"
                          : "nav nav-treeview no_display"
                      }
                    >
                      <li className="nav-item">
                        <Link
                          to="/subscription"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/subscription"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Connect to SRMS</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item" id="admin">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("admin");
                      }}
                      style={name.superAdmin === true ? null : { opacity: 0.4 }}
                      className={
                        props.match.url === "/users" ||
                        props.match.url === "/log" ||
                        props.match.url === "/notification"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon far fa-bell"></i>
                      <p>
                        Admin and Security
                        <i className="fas fa-angle-left right"></i>
                      </p>
                    </a>

                    <ul
                      className={
                        name.superAdmin === true
                          ? "nav nav-treeview no_display"
                          : "nav nav-treeview no_display"
                      }
                    >
                      <li className="nav-item">
                        <Link
                          to="/users"
                          style={
                            name.superAdmin === true ? null : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/users"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Accounts</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/log"
                          style={
                            name.superAdmin === true ? null : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/log"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Logs</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/notification"
                          style={
                            name.superAdmin === true ? null : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/notification"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Notifications</p>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item" id="reports">
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        changeDisplay("reports");
                      }}
                      style={
                        name.superAdmin === true || name.admin === true
                          ? null
                          : { opacity: 0.4 }
                      }
                      className={
                        props.match.url === "/analyticreport" ||
                        props.match.url === "/videoreport" ||
                        props.match.url === "/subscriptionReport"
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon far fa-file"></i>
                      <p>
                        Reports
                        <i className="fas fa-angle-left right"></i>
                      </p>
                    </a>
                    <ul
                      className={
                        name.superAdmin === true || name.admin === true
                          ? "nav nav-treeview"
                          : "nav nav-treeview"
                      }
                    >
                      <li className="nav-item">
                        <Link
                          to="/videoreport"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/videoreport"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>
                            Video Reports
                            {/* <i className="fas fa-angle-left right"></i> */}
                          </p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/analyticreport"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/analyticreport"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Analytic Report</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/subscriptionreport"
                          style={
                            name.superAdmin === true || name.admin === true
                              ? null
                              : { opacity: 0.4 }
                          }
                          className={
                            props.match.url === "/subscriptionReport"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>Subscription Report</p>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-header">Support</li>
                  <li className="nav-item">
                    <a href="#!" className="nav-link">
                      <i className="nav-icon fas fa-ellipsis-h"></i>
                      <p>Raise a Ticket</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#!" className="nav-link">
                      <i className="nav-icon fas fa-ellipsis-h"></i>
                      <p>Tickets</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#!" className="nav-link">
                      <i className="nav-icon fas fa-file"></i>
                      <p>Documentation</p>
                    </a>
                  </li>
                </ul>{" "}
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    );
  } else {
    return <></>;
  }
};
export default Sidebar;
